module.exports = __webpack_public_path__ + "static/img/app3.09d4b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app3.jpg
// module id = hQVc
// module chunks = 1